// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2a7d5e1","517":"5a0e3609","659":"4e955d41","701":"8566a827"}[chunkId] + ".chunk.js";
};